// CustomButton.jsx
import React from "react";
import PropTypes from "prop-types";
import { Button, CircularProgress } from "@mui/material";

const CustomButton = ({
  label,
  onClick,
  variant,
  color,
  fullWidth,
  height,
  width,
  disabled,
  backgroundColor,
  borderRadius,
  icon,
  loading,
  
  ...restProps
}) => {
  const isOutlined = variant === "outlined";
  return (
    <Button
      onClick={onClick}
      variant={isOutlined ? "outlined" : "contained"}
     
      color={color || "primary"}
      fullWidth={fullWidth || false}
      disabled={disabled || loading || false}
      style={{
        height: height || "auto",
        width: width || "auto",
        backgroundColor: backgroundColor || "", // Set your default background color
        borderRadius: borderRadius || "4px",
        position: 'relative', // Add this line to handle loading spinner position
      }}
      startIcon={icon} // Use startIcon or endIcon to place the icon
      {...restProps}
    >
      {label}
      {loading && (
        <CircularProgress
          size={20}
          style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
        />
      )}
    </Button>
  );
};

CustomButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.string,
  color: PropTypes.string,
  fullWidth: PropTypes.bool,
  height: PropTypes.number,
  width: PropTypes.string,
  backgroundColor: PropTypes.string,
  borderRadius: PropTypes.string,
  icon: PropTypes.element, // Ensure icon is passed as an element
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
};

export default CustomButton;
